"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadcastChatsContext = void 0;
const ChatsContext_1 = require("./ChatsContext");
exports.BroadcastChatsContext = (0, ChatsContext_1.createChatContext)();
